import script from "./UserPostsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserPostsView.vue?vue&type=script&setup=true&lang=ts"

import "./UserPostsView.vue?vue&type=style&index=0&id=72047fa8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72047fa8"]])

export default __exports__